export enum LabelFilter {
    Config = 1,    
    Job = 2
}